import { render, staticRenderFns } from "./cookiesDialog.vue?vue&type=template&id=25b78aa8&scoped=true"
import script from "./cookiesDialog.vue?vue&type=script&lang=js"
export * from "./cookiesDialog.vue?vue&type=script&lang=js"
import style0 from "./cookiesDialog.vue?vue&type=style&index=0&id=25b78aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b78aa8",
  null
  
)

export default component.exports